import React from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';

import flow from 'lodash/flow';

import {
  Button,
  ButtonRow,
  Callout,
  FormLayout,
  Heading,
  HorizontalRule,
  IconDining,
  IconStatusYes,
  IconTravel,
  IconTransferGlobal,
  IconAlertActive,
  IconLocationActive,
  IconGlobal,
  IconShoppingCart,
  IconHealth,
  IconVoiceActive,
  IconFavouriteStarActive,
  IconUser,
  Image,
  ListItem,
  Link,
  Panel,
  Paragraph,
  PlaybackKey,
  PlaybackList,
  PlaybackValue,
  Section,
  IconSecurityHsbcServices,
  UnorderedList,
  withTrackPage,
} from '@piggybank/core';
import {
  Form,
} from '@piggybank/form';

import { withAppContext } from '~/AppContext';

import ProductTile from '~/components/ProductTile';

import { offerMap, formatAmountFromPath } from '~/utils';
import { formatAddress, isButtonVisible, isImageHorizontal, NLS } from './cardDetailsFunctions';
import format from 'date-fns/format';

import { getImageUrl, getIntrinsicSizeByCardType } from '~/pages/CardDetails/cardDetailsFunctions';

import styles from './card-details.module.css';

import getEnvironment from '~/lib/environment';
const environment = getEnvironment();

const CardDetails = ({ data }) => {
  let productType = offerMap(data.initialData.globalData.offerId);
  let addressStr = formatAddress(get(data.initialData.offer, 'customerDetails.contactDetails.residentialAddress'));
  let url = getImageUrl(productType);
  let intrinsicSize = getIntrinsicSizeByCardType(productType);
  const heading = get(data.initialData.offer, 'creditCardOffer.heading');
  const propsWithDefaults = {
    productName: heading,
    value: productType,
    labelProps: { name: heading },
    imageSlot: <Image alt={`${NLS`Image of`} ${heading}`} intrinsicSize={intrinsicSize} marginBottom={0} src={url || '#'} />,
    isHorizontal: isImageHorizontal(intrinsicSize),
  };
  return (
    <FormLayout>
      <Section>
        <Heading level={1} marginBottom={6}>
          {heading}
        </Heading>
        <ProductTile {...propsWithDefaults}>

          {productType === '2now' &&
            <>
              <div className={styles.row}>
                <div className={styles.iconOther}>
                  <IconShoppingCart inline/>
                </div>
                <div>
                  {NLS`Receive 2% of your purchases in HSBC 2 NOW¹ balance on your card.`}
                </div>
              </div>
              <div className={styles.row}>
                <div className={styles.iconOther}>
                  <IconAlertActive inline/>
                </div>
                <div>
                  {NLS`Exempts the cardholders card administration fee, you must only accumulate purchases equal to or greater than $3,500.00 MXN.³ per month.`}
                </div>
              </div>
              <div className={styles.row}>
                <div className={styles.iconOther}>
                  <IconVoiceActive inline/>
                </div>
                <div>
                  {NLS`Enjoy your favorite concerts, buy your tickets before anyone else, with up to 10 months interest-free, bonuses, and much more⁴.`}
                </div>
              </div>
            </>
          }
          {productType === 'one' &&
            <>
              <div className={styles.row}>
                <div className={styles.iconOther}>
                  <IconShoppingCart inline/>
                </div>
                <div>
                  {NLS`Get 5% cashback on purchases at:Restaurants, travel, entertainment, health, and international shopping.`}
                </div>
              </div>
              <div className={styles.row}>
                <div className={styles.iconOther}>
                  <IconTravel inline/>
                </div>
                <div>
                  {NLS`Enjoy access to VIP lounges at AICM and AIFA.`}
                </div>
              </div>
              <div className={styles.row}>
                <div className={styles.iconOther}>
                  <IconHealth inline/>
                </div>
                <div>
                  {NLS`Protection with travel assistance and insurance.`}
                </div>
              </div>
            </>
          }
          {productType === 'gold' &&
                    <>
                      <div className={styles.row}>
                        <div className={styles.iconStatusYes}>
                          <IconStatusYes inline/>
                        </div>
                        <div>
                          <strong>{NLS`Accumulate points`}</strong>{' '}{NLS`with every purchase and turn them into travel experiences; plus, get:`}
                        </div>
                      </div>
                      <div className={styles.row}>
                        <div className={styles.iconOther}>
                          <IconTravel inline/>
                        </div>
                        <div>
                          {NLS`Welcome domestic flight`}
                        </div>
                      </div>
                      <div className={styles.row}>
                        <div className={styles.iconOther}>
                          <IconTransferGlobal inline/>
                        </div>
                        <div>
                          {NLS`Anniversary flight to Mexico or the US`}
                        </div>
                      </div>

                     <div className={styles.row}>
                       <div className={styles.iconOther}>
                         <IconShoppingCart inline/>
                       </div>
                       <div>
                         {NLS`3 months interest-free on purchases made abroad.`}
                       </div>
                     </div>
                    </>
          }

          {productType === 'platinum' &&
                     <>
                       <div className={styles.row}>
                         <div className={styles.iconStatusYes}>
                           <IconStatusYes inline/>
                         </div>
                         <div>
                           <strong>{NLS`Accumulate points`}</strong>{' '}{NLS`with every purchase and enjoy exclusive benefits that transform every trip:`}
                         </div>
                       </div>
                       <div className={styles.row}>
                         <div className={styles.iconOther}>
                           <IconDining inline/>
                         </div>
                         <div>
                           {NLS`Unlimited access to LoungeKey`}
                         </div>
                       </div>
                       <div className={styles.row}>
                         <div className={styles.iconOther}>
                           <IconSecurityHsbcServices inline/>
                         </div>
                         <div>
                           {NLS`Complimentary Global Entry`}
                         </div>
                       </div>
                       <div className={styles.row}>
                         <div className={styles.iconOther}>
                           <IconTravel inline/>
                         </div>
                         <div>
                           {NLS`Domestic welcome flight`}
                         </div>
                       </div>
                       <div className={styles.row}>
                         <div className={styles.iconOther}>
                           <IconTransferGlobal inline/>
                         </div>
                         <div>
                           {NLS`Anniversary flight to Mexico, the US, and Europe`}
                         </div>
                       </div>
                        <div className={styles.row}>
                          <div className={styles.iconOther}>
                            <IconShoppingCart inline/>
                          </div>
                          <div>
                            {NLS`6 months interest-free on international purchases`}
                          </div>
                        </div>

                     </>
          }

          {productType === 'zero' &&
            <>
              <div className={styles.row}>
                <div className={styles.iconOther}>
                  <IconShoppingCart inline/>
                </div>
                <div>
                  {NLS`Exempts the cardholders card administration fee, you must only accumulate purchases equal to or greater than $300.00 MXN.¹ per month.`}
                </div>
              </div>
              <div className={styles.row}>
                <div className={styles.iconOther}>
                  <IconVoiceActive inline/>
                </div>
                <div>
                  {NLS`Enjoy your favorite concerts, buy your tickets before anyone else, with up to 10 months interest-free, bonuses, and much more³.`}
                </div>
              </div>
            </>
          }

          {productType === 'air' &&
            <>
              <div className={styles.row}>
                <div className={styles.iconOther}>
                  <IconShoppingCart inline/>
                </div>
                <div>
                  {NLS`Pay up to`}{' '}{NLS`half`}{' '}{NLS`of the interest`}
                </div>
              </div>
              <div className={styles.row}>
                <div className={styles.iconOther}>
                  <IconAlertActive inline/>
                </div>
                <div>
                  {NLS`3 months interest-free* automatic payment on purchases over $3,000 MXN.`}
                </div>
              </div>
              <div className={styles.row}>
                <div className={styles.iconOther}>
                  <IconVoiceActive inline/>
                </div>
                <div>
                  {NLS`Enjoy your favorite concerts, buy your tickets before anyone else, with up to 10 months interest-free, bonuses, and much more³.`}
                </div>
              </div>
            </>
          }

          {productType === 'pwe' &&
            <>
              <div className={styles.row}>
                <div className={styles.iconOther}>
                  <IconGlobal inline/>
                </div>
                <div>
                  {NLS`Enjoy unlimited LoungeKey access.²`}
                </div>
              </div>
              <div className={styles.row}>
                <div className={styles.iconOther}>
                  <IconShoppingCart inline/>
                </div>
                <div>
                  {NLS`Interest-free months* abroad at no cost.`}
                </div>
              </div>
              <div className={styles.row}>
                <div className={styles.iconOther}>
                  <IconFavouriteStarActive inline/>
                </div>
                <div>
                  {NLS`Personalized travel assistance and dining³ with Mastercard Concierge World Elite 24/7, and priceless experiences in travel, entertainment, art, and culture.`}
                </div>
              </div>
              <div className={styles.row}>
                <div className={styles.iconOther}>
                  <IconLocationActive inline/>
                </div>
                <div>
                  {NLS`FREE parking for up to 5 days with AICM Mastercard Elite Valet.⁴`}
                </div>
              </div>
            </>
          }

          {productType === 'viva' &&
            <>
              <div className={styles.row}>
                <div className={styles.iconStatusYes}>
                  <IconStatusYes inline/>
                </div>
                <div>
                  <strong>{NLS`No annuity.`}</strong>{' '}{NLS`Receive a 20,000 point Bonus by spending $20,000 M.N. the first 3 months and 2 points for every $10 M.N. shopping.`}
                </div>
              </div>
              <div className={styles.row}>
                <div className={styles.iconOther}>
                  <IconTravel inline/>
                </div>
                <div>
                  {NLS`Baggage free of charge`}
                </div>
              </div>
              <div className={styles.row}>
                <div className={styles.iconOther}>
                  <IconUser inline/>
                </div>
                <div>
                  {NLS`Priority Boarding`}
                </div>
              </div>
              <div className={styles.row}>
                <div className={styles.iconOther}>
                  <IconDining inline/>
                </div>
                <div>
                  {NLS`Lounge Access`}
                </div>
              </div>
            </>
          }
          {productType === 'vivaPlus' &&
            <>
              <div className={styles.row}>
                <div className={styles.iconStatusYes}>
                  <IconStatusYes inline/>
                </div>
                <div>
                  <strong>{NLS`Free annuity the first year.`}</strong>{' '}{NLS`Receive a Bonus of 35,000 points spending $60,000 M.N. the first 3 months and up to 3 points for every $10 M.N. in purchases.`}
                </div>
              </div>
              <div className={styles.row}>
                <div className={styles.iconOther}>
                  <IconTravel inline/>
                </div>
                <div>
                  {NLS`Baggage free of charge`}
                </div>
              </div>
              <div className={styles.row}>
                <div className={styles.iconOther}>
                  <IconUser inline/>
                </div>
                <div>
                  {NLS`Priority Boarding`}
                </div>
              </div>
              <div className={styles.row}>
                <div className={styles.iconOther}>
                  <IconDining inline/>
                </div>
                <div>
                  {NLS`Lounge Access`}
                </div>
              </div>
            </>
          }
        </ProductTile>
        <Heading accentBar level={2}>
          {NLS`Offer conditions`}
        </Heading>
        <Panel>
          <PlaybackList>
            <PlaybackKey>{NLS`Credit limit`}</PlaybackKey>
            <PlaybackValue type="large">{formatAmountFromPath(data.initialData.offer, 'creditCardOffer.creditLimit.amount')}</PlaybackValue>
            <PlaybackKey>
              {productType === 'viva' || productType === 'vivaPlus' ? NLS`Weighted average CAT` : NLS`CAT Weighted Average`}
            </PlaybackKey>
            <PlaybackValue type="large">{`${get(data.initialData.offer, 'creditCardOffer.totalAnnualCost')} ${NLS`without IVA`}`}</PlaybackValue>
            <PlaybackKey>
              {productType === 'air' || productType === 'viva' || productType === 'vivaPlus' ? NLS`Ordinary annual interest rate` : NLS`Ordinary annual interest rate, Variable`}
            </PlaybackKey>
            <PlaybackValue type="large">{get(data.initialData.offer, 'creditCardOffer.annualInterestRate')}</PlaybackValue>
          </PlaybackList>
          <HorizontalRule marginBottom={4} />
          <PlaybackList>
            <PlaybackKey>{NLS`Calculation date`}</PlaybackKey>
            <PlaybackValue>{format(get(data.initialData.offer, 'creditCardOffer.totalAnnualCostDate'), 'DD/MM/YYYY')}</PlaybackValue>
            <PlaybackKey>{NLS`Cardholder Management without VAT`}</PlaybackKey>
            <PlaybackValue>{get(data.initialData.offer, 'creditCardOffer.annuity')}</PlaybackValue>
            <PlaybackKey>{NLS`Offer validity`}</PlaybackKey>
            <PlaybackValue>{format(get(data.initialData.offer, 'creditCardOffer.expiryDate'), 'DD/MM/YYYY')}</PlaybackValue>
            <PlaybackKey>{NLS`Contract Registration Number`}</PlaybackKey>
            <PlaybackValue marginBottom={0}>{get(data.initialData.offer, 'creditCardOffer.contractRegistrationNumber')}</PlaybackValue>
          </PlaybackList>
        </Panel>
        <Heading accentBar level={2}>
          {NLS`Delivery conditions`}
        </Heading>
        <UnorderedList>
          <Panel>
            <PlaybackList type="strong">
              <PlaybackValue marginBottom={0}>{addressStr}</PlaybackValue>
            </PlaybackList>
          </Panel>
          <ListItem>{NLS`You will receive your card, cover and annex of commissions in a maximum of`}{' '}<strong>{NLS`5 business days`}</strong>{' '}{NLS`at your registered address. Once you use your card, these documents will be understood as accepted.`}</ListItem>
          <ListItem>{NLS`If you want to`}{' '}<strong>{NLS`change the shipping address`}</strong>{' '}{NLS`contact`}{' '}<strong>{NLS`55 5721 1168 option 2,`}</strong>{' '}{NLS`you have`}{' '}<strong>{NLS`3 working days`}</strong>{' '}{NLS`from this moment.`}</ListItem>
        </UnorderedList>
        <Heading accentBar level={2}>
          {NLS`Terms and Conditions`}
        </Heading>
        <Callout type="information">
          <Paragraph marginBottom={0}>
            {NLS`Important Information`}
          </Paragraph>
        </Callout>
        <UnorderedList marginBottom={0}>
          <ListItem>
            {
              productType === '2now' ?
                NLS`See the comparison table, source, date of preparation and validity, as well as restrictions, requirements, terms, contracting conditions, commissions, and legal information in` :
                productType === 'air' ?
                  NLS`See the comparison table, source, date of preparation and validity, as well as restrictions, requirements, terms, contracting conditions, commissions, and legal information in` :
                  productType === 'zero' ?
                    NLS`See the comparison table, source, date of preparation and validity, as well as restrictions, requirements, terms, contracting conditions, commissions, and legal information in`:
                    NLS`See the comparison table, source, date of preparation and validity, as well as restrictions, requirements, terms, contracting conditions, commissions, and legal information in`
            }
            :{' '}<Link href={NLS`${productType}-url`}>{NLS`${productType}-url`}</Link>
          </ListItem>
          <ListItem>{NLS`By accepting the offer you confirm that you know the content of the Contract, which you consent to and remains at your disposal in`}:{' '}<Link href="https://www.hsbc.com.mx">{'https://www.hsbc.com.mx'}</Link></ListItem>
          <ListItem marginBottom={0}>{NLS`Issuer of the Credit Card HSBC México S.A. Institution of Multiple Banking, Grupo Financiero HSBC.`}</ListItem>
        </UnorderedList>
      </Section>
      <Form initialValues={{ agree: false }} >
        <Section>
          <ButtonRow>
            <Button id={data.initialData.globalData.offerId}>{NLS`Accept`}</Button>
            {isButtonVisible(data.initialData.globalData.ismobile) &&
              <Button elementType="a" href={environment.bankingDashboardUrl} secondary target="_self">{NLS`Back`}</Button>
            }
          </ButtonRow>
        </Section>
      </Form>
    </FormLayout>
  );
};

CardDetails.propTypes = {
  data: PropTypes.shape({
    initialData: PropTypes.shape({
      globalData: PropTypes.object,
      ismobile: PropTypes.string,
      offer: PropTypes.object,
    }),
  }),
};

export default flow(
  withAppContext(),
  withTrackPage('cardDetails', 'component')
)(CardDetails);
